import React from "react";
import orderBy from "lodash/orderBy";
import PropTypes from "prop-types";
import userShape from "shapes/current_user";

import Dropdown, {
  DropdownButton,
  DropdownUserItem,
  DropdownUserSelect,
} from "components/Dropdown";
import { pushToFront } from "utils";

const Input = (props) =>
  props.value ? ( // eslint-disable-line
    <DropdownButton>
      <DropdownUserSelect {...props} />
    </DropdownButton>
  ) : (
    <DropdownUserSelect {...props} />
  );

const UsersDropdown = ({ currentUser, onSelect, selectedUser, users }) => (
  <Dropdown
    component={DropdownUserItem}
    componentProps={{ currentUser }}
    inputComponent={Input}
    inputComponentProps={{ user: selectedUser }}
    isFullWidth={false}
    onChange={onSelect}
    selectedValues={[selectedUser]}
    values={pushToFront(orderBy(users, ["lname", "fname"]), currentUser)}
  />
);

UsersDropdown.propTypes = {
  currentUser: PropTypes.shape(userShape),
  selectedUser: PropTypes.shape(userShape),
  users: PropTypes.arrayOf(PropTypes.shape(userShape)).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default UsersDropdown;
